import axios from 'axios';

const coopExternalConfirmCancel = async ({
  appointmentId,
  status,
  details,
  isPending = false,
  dashboardId,
}: {
  appointmentId: string;
  status: 'confirm' | 'cancel';
  details?: string;
  isPending?: boolean;
  dashboardId: string;
}) => {
  const { data } = await axios.post(`/external/dash/${dashboardId}/status`, {
    status,
    details,
    isPending,
    appointmentId,
  });
  return data;
};

export default coopExternalConfirmCancel;
